<template>
  <base-review-member-list-item
    class="assign-review-members-list-item"
    :researcher="researcher"
    @click="$emit('click')"
  >
    <template v-if="selected" #right>
      <v-icon color="primary">check</v-icon>
    </template>
  </base-review-member-list-item>
</template>

<script>
import BaseReviewMemberListItem from './BaseReviewMemberListItem';
import { ReviewMember } from '@/models';

export default {
  name: 'AssignReviewMembersListItem',
  components: { BaseReviewMemberListItem },
  props: {
    reviewMember: {
      type: ReviewMember,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    researcher() {
      return this.reviewMember.researcher;
    },
  },
};
</script>

<style lang="scss" scoped>
.assign-review-members-list-item {
  position: relative;
  cursor: pointer;
  user-select: none;
}
.assign-review-members-list-item:hover::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
</style>
